import * as actionTypes from '../actions/actionTypes';

import updateObject from '../../util/updateObject';

const initialState = {
    isInstalled: false, 
    promptEvent:  null
};

const updateEvent = (state, action) => {
    return updateObject(state, { promptEvent: action.event });
}

const markAsInstalled = (state, action) => {
    return updateObject(state, { isInstalled: true, promptEvent: null })
}

const clearInstallEvent = (state, action) => {
    return updateObject(state, { promptEvent: null });
}

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.A2HS_SUCCESS: return markAsInstalled(state, action);
        case actionTypes.A2HS_SAVE_EVENT: return updateEvent(state, action);
        case actionTypes.A2HS_CLEAR: return clearInstallEvent(state, action);
        default: return state;
    }
}

export default reducer;